import React from "react";
import ReactDom from "react-dom/client";
import App from "./App";
var rootElement = document.getElementById("root");
if (rootElement) {
    var root = ReactDom.createRoot(rootElement);
    root.render(React.createElement(App, null));
}
else {
    console.error("rootElement not found");
}
